"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Placeholder = void 0;

var _react = _interopRequireDefault(require("react"));

var _xCore = require("@goodrx/x-core");

var _components = require("./components");

var __jsx = _react["default"].createElement;

var Placeholder = function Placeholder(props) {
  var type = props.type;
  var componentMap = {
    "default": function _default() {
      return __jsx("div", null);
    },
    hd_hp_press: function hd_hp_press() {
      return __jsx(_components.HDHomePressLinks, props);
    }
  };
  return (0, _xCore.renderFromComponentMap)(componentMap, type || 'default');
};

exports.Placeholder = Placeholder;